import { render, staticRenderFns } from "./OTP.vue?vue&type=template&id=e35c9682&scoped=true"
import script from "./OTP.vue?vue&type=script&lang=ts"
export * from "./OTP.vue?vue&type=script&lang=ts"
import style0 from "./OTP.vue?vue&type=style&index=0&id=e35c9682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35c9682",
  null
  
)

export default component.exports